import { ActionTree, GetterTree, MutationTree } from "vuex";
import api from "@/modules/common/api";

export enum ESensor {
    PIEZOMETER = 0,
    WATER_LEVEL_MONITOR = 1,
    DISPLACEMENT_TRANSDUCER = 2
}

export interface ISensor {
    kind: ESensor;
    name: string;
}

export enum EReading {
    READING = 0,
    RESULT = 1,
    TEMPERATURE = 2
}

export interface ISensorReading {
    epoch: string;
    value: number;
    kind: EReading;
}

export interface ISensorsState {
    sensors: ISensor[];
}

export interface IAvailableType {
    text: string;
    value: ESensor;
}

const initialState: ISensorsState = {
    sensors: []
};

const mutations: MutationTree<ISensorsState> = {
    SET_SENSORS(state, sensors): void {
        state.sensors = sensors;
    }
};

const actions: ActionTree<ISensorsState, any> = {
    async initialize({ commit, rootState }): Promise<void> {
        const { data } = await api.getSensors(rootState.common.source);
        commit("SET_SENSORS", data);
    }
};

const getters: GetterTree<ISensorsState, any> = {
    availableTypes(state: ISensorsState): IAvailableType[] {
        const { sensors } = state;
        const availableTypes: IAvailableType[] = [
            { text: "Piezômetros", value: ESensor.PIEZOMETER },
            { text: "Medidores de vazão", value: ESensor.WATER_LEVEL_MONITOR },
            {
                text: "Extensômetros de haste",
                value: ESensor.DISPLACEMENT_TRANSDUCER
            }
        ];
        return availableTypes.filter(
            availableType =>
                !!sensors.find(sensor => sensor.kind === availableType.value)
        );
    }
};

export default {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
    getters
};
